import { LoginSection } from 'LoginUI';
import {
  DisplayMnemonic,
  DisplayWif,
  DisplayAddress,
  GetThePrivateKeyFromTheMnemonic,
  UnregisterAddress,
  UnregisterCredential,
  SavePasswordEncryptedSecrets,
  LoadPasswordEncryptedSecrets,
} from 'SettingAll';
import { useGlobalStateSelector, words } from 'globalState';
import { handleClickGoTop, handleClickActivationScreen } from 'monadomCore';
import { SelectSessionButton } from 'KeysAndSigningUI';
import { TextLine3 } from 'UtilComponents';
import {
  makeLiveTextUrlForABroadcaster,
  disconnectConnectionForABroadcaster,
  buildLiveTextUrl,
} from './broadcast';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';

// SETTING
function Setting() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  let urlForABroadcaster;

  if (
    state.makeUrlToBroadcast.addressMain !== undefined && state.makeUrlToBroadcast.addressMain !== null && state.makeUrlToBroadcast.addressMain !== '' &&
    state.makeUrlToBroadcast.addressOperator !== undefined && state.makeUrlToBroadcast.addressOperator !== null && state.makeUrlToBroadcast.addressOperator !== '' &&
    state.makeUrlToBroadcast.clientTime !== undefined && state.makeUrlToBroadcast.clientTime !== null && state.makeUrlToBroadcast.clientTime !== '' &&
    state.config.clientParameters?.signatureVersion?.makeUrlToBroadcast !== undefined && state.config.clientParameters?.signatureVersion?.makeUrlToBroadcast !== null && state.config.clientParameters?.signatureVersion?.makeUrlToBroadcast !== '' &&
    state.makeUrlToBroadcast.signature !== undefined && state.makeUrlToBroadcast.signature !== null && state.makeUrlToBroadcast.signature !== '' &&
    state.makeUrlToBroadcast.connectionMatchingId !== undefined && state.makeUrlToBroadcast.connectionMatchingId !== null && state.makeUrlToBroadcast.connectionMatchingId !== ''
  ) {
    urlForABroadcaster = buildLiveTextUrl({
      addressMain: state.makeUrlToBroadcast.addressMain,
      addressOperator: state.makeUrlToBroadcast.addressOperator,
      clientTime: state.makeUrlToBroadcast.clientTime,
      signatureVersion: state.config.clientParameters.signatureVersion.makeUrlToBroadcast,
      signature: state.makeUrlToBroadcast.signature,
      connectionMatchingId: state.makeUrlToBroadcast.connectionMatchingId,
    });
  }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn">
        { headerRelative }
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
          <div className='widthMax marginTop1 '>
              { words.makeLiveTextUrlForABroadcaster[state.language] }
          </div>
          <div className='flexRow alignItemsCenter marginTopBottom0p5 '>
              <TextLine3 fieldName='makeUrlToBroadcastAddressMainPc' keys={['makeUrlToBroadcast', 'addressMain']} face={words.addressMain[state.language]} tooltip='right' />
              <SelectSessionButton stateKeysToSetAddress={[['makeUrlToBroadcast', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          </div>
          <div className='flexRow alignItemsCenter marginTopBottom0p5 '>
              <TextLine3 fieldName='makeUrlToBroadcastAddressOperatorPc' keys={['makeUrlToBroadcast', 'addressOperator']} face={words.addressOperator[state.language]} tooltip='right' />
              <SelectSessionButton stateKeysToSetAddress={[['makeUrlToBroadcast', 'addressOperator']]} stateKeysToSetUserName={[]} loginEnabled={false} />
          </div>
          <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ async () => {
                await makeLiveTextUrlForABroadcaster(state, dispatch);
              }}
          >
              { words.makeUrl[state.language] }
          </button>
          <div className='flexRow alignItemsCenter ' >
              <div className='box4 breakAll padding0p5 margin1' >
              { urlForABroadcaster }
              </div>
              <button className='button1' tabindex='0' 
              onClick={ async () => {
                  try {
                    await navigator.clipboard.writeText(urlForABroadcaster);

                    dispatch({
                      type: 'setNotification',
                      key: 'notification',
                      value: words.urlHasBeenCopiedToTheClipboard[state.language],
                    });
                  }
                  catch {
                    dispatch({
                      type: 'setNotification',
                      key: 'notification',
                      value: words.failedToCopyUrlToTheClipboard[state.language],
                    });
                  }
              }}
              >
              <img className='size2x2' src={iconCopy} alt='' />
              </button>
          </div>
          <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ async () => {
                await disconnectConnectionForABroadcaster(state, dispatch);
              }}
          >
              { words.disconnect[state.language] }
          </button>
        </div>
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
          <div className='widthMax marginTop1 '>
            { words.activationOfTheMonatokaPoint[state.language] }
          </div>
          <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
            onClick={ () => {
              handleClickActivationScreen(navigate);
            }}
          >
            <div>
              { words.activationScreen[state.language] }
            </div>
          </button>
        </div>
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
          <div className='widthMax marginTop1 '>
            { words.ifYouEncounterContinuousServerErrorsThatPreventYouFromDuelingPleaseLogInHere[state.language] }
          </div>
          <LoginSection mode='clearDuelAndConnection' />
        </div>
        {/*
          process.env.REACT_APP_ENVIRONMENT === 'dev' ?
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div>
                { words.swapMnemonics[state.language] }
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearAddress(state, dispatch) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                handleClickSwapMnemonics(state, dispatch);
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} />
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
              { state.displaySecret.address }
            </div>
          </div>
          : null
        */}
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        { headerRelative }
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
        {/*
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div>
                { words.displayMnemonic[state.language] }
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearMnemonic({ dispatch }) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <div className='widthMax colorRed marginTop1 '>
              { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics) => handleClickDisplayMnemonic({ dispatch, mnemonics });
                handleClickNfc(state, dispatch, callback, { args: ['mnemonics'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} alt='keycard' />
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics) => handleClickDisplayMnemonic({ dispatch, mnemonics });
                handleClickScanQr(state, dispatch, callback, { args: ['mnemonics'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconQr} alt='qr' />
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
              { state.displaySecret.mnemonic }
            </div>
          </div>
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div>
                { words.displayWif[state.language] }
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearWif(state, dispatch) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <div className='widthMax colorRed marginTop1 '>
              { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics, keyPairs) => handleClickDisplayWif(state, dispatch, mnemonics, keyPairs);
                handleClickNfc(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} alt='keycard' />
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics, keyPairs) => handleClickDisplayWif(state, dispatch, mnemonics, keyPairs);
                handleClickScanQr(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconQr} alt='qr' />
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
              { state.displaySecret.wif }
            </div>
          </div>
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div>
                { words.displayAddress[state.language] }
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearAddress(state, dispatch) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics, keyPairs) => handleClickDisplayAddress(state, dispatch, mnemonics, keyPairs);
                handleClickNfc(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} alt='keycard' />
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                const callback = (mnemonics, keyPairs) => handleClickDisplayAddress(state, dispatch, mnemonics, keyPairs);
                handleClickScanQr(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconQr} alt='qr' />
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
              { state.displaySecret.address }
            </div>
          </div>
        */}
        {/*
          process.env.REACT_APP_ENVIRONMENT === 'dev' ?
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div>
                { words.swapMnemonics[state.language] }
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearAddress(state, dispatch) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                handleClickSwapMnemonics(state, dispatch);
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} />
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ async () => {
                localStorage.removeItem('swapStatus');
                localStorage.removeItem('oldAddress');
                localStorage.removeItem('oldKeyPair');
                localStorage.removeItem('oldMnemonic');
                localStorage.removeItem('newAddress');
                localStorage.removeItem('newMnemonic');
                localStorage.removeItem('sweepAssetsTxid');
                localStorage.removeItem('sendMonaTxid');
                dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: '' }); // 暫定
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
              <div>
                <img className='size2x2' src={iconKeyCard} />
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
              { state.displaySecret.swapMnemonics }
            </div>
          </div>
          : null
        */}
        {/*
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
              <div className='flexColumn alignItemsFlexStart '>
                <div>
                  { words.getThePrivateKeyFromTheMnemonic[state.language] }
                </div>
                <div>
                  { words.restoringToAnotherWalletFromABackup[state.language] }
                </div>
              </div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
                onClick={ () => handleClickClearMnemonicAndWif(state, dispatch) }
              >
                {words.clear[state.language]}
              </button>
            </div>
            <div className='widthMax colorRed marginTop1 '>
              { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
            </div>
            <TextArea2 fieldName='settingWifFromMnemonic' keys={['displaySecret', 'mnemonicToWif']} face={words.mnemonic[state.language]}
              outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
            />
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ () => {
                handleClickDisplayWifFromMnemonicFilledIn(state, dispatch);
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
            </button>
            <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
              { state.displaySecret.wifFromMnemonic }
            </div>
          </div>
        */}
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <div className='widthMax marginTop1 '>
              { words.makeLiveTextUrlForABroadcaster[state.language] }
            </div>
            <div className='flexRow alignItemsCenter marginTopBottom0p5 '>
              <TextLine3 fieldName='makeUrlToBroadcastAddressMainSp' keys={['makeUrlToBroadcast', 'addressMain']} face={words.addressMain[state.language]} tooltip='right' />
              <SelectSessionButton stateKeysToSetAddress={[['makeUrlToBroadcast', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false} />
            </div>
            <div className='flexRow alignItemsCenter marginTopBottom0p5 '>
              <TextLine3 fieldName='makeUrlToBroadcastAddressOperatorSp' keys={['makeUrlToBroadcast', 'addressOperator']} face={words.addressOperator[state.language]} tooltip='right' />
              <SelectSessionButton stateKeysToSetAddress={[['makeUrlToBroadcast', 'addressOperator']]} stateKeysToSetUserName={[]} loginEnabled={false} />
            </div>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ async () => {
                await makeLiveTextUrlForABroadcaster(state, dispatch);
              }}
            >
              { words.makeUrl[state.language] }
            </button>
            <div className='box4 width90PC height12 breakAll padding0p5 marginTop1 ' >
              { urlForABroadcaster }
            </div>
            <button className='button1' tabindex='0' 
              onClick={ async () => {
                try {
                  await navigator.clipboard.writeText(urlForABroadcaster);

                  dispatch({
                    type: 'setNotification',
                    key: 'notification',
                    value: words.urlHasBeenCopiedToTheClipboard[state.language],
                  });
                }
                catch {
                  dispatch({
                    type: 'setNotification',
                    key: 'notification',
                    value: words.failedToCopyUrlToTheClipboard[state.language],
                  });
                }
              }}
            >
              <img className='size2x2' src={iconCopy} alt='' />
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ async () => {
                await disconnectConnectionForABroadcaster(state, dispatch);
              }}
            >
              { words.disconnect[state.language] }
            </button>
          </div>
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
          <div className='widthMax marginTop1 '>
            { words.activationOfTheMonatokaPoint[state.language] }
          </div>
          <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
            onClick={ () => {
              handleClickActivationScreen(navigate);
            }}
          >
            <div>
              { words.activationScreen[state.language] }
            </div>
          </button>
        </div>
        <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
          <div className='widthMax marginTop1 '>
            { words.ifYouEncounterContinuousServerErrorsThatPreventYouFromDuelingPleaseLogInHere[state.language] }
          </div>
          <LoginSection mode='clearDuelAndConnection' />
        </div>
        {/*
          process.env.REACT_APP_ENVIRONMENT === 'dev' ?
          <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
              onClick={ () => {
                writeMnemonicOnNfc(state, dispatch);
              }}
            >
              <div>
                { words.display[state.language] }
              </div>
            </button>
          </div>
          : null
        */}
      </div>
      { headerFixed }
    </div>
  );
}

export {
  Setting,
};
